<div class="klab-input-text klab-input-text--{{ variant }}">
    <label *ngIf="label" class="klab-input__label">
        {{ label }}
    </label>
    <div class="klab-input-text__control" [class.error]="hasError">
        <core-ui-input-base #inputRef="coreInputBase" [type]="showPassword ? 'text' : type" [placeholder]="placeholder"
            [variant]="variant === 'search-large' ? 'search-large' : 'default'"
            [disabled]="disabled" [value]="value ?? ''" (valueChange)="handleValueChange($event)" (blur)="handleBlur()">
        </core-ui-input-base>
        <div class="klab-input-text__icons-right" *ngIf="hasError || showClearIcon || (iconRight && !hasError)">
            <img *ngIf="hasError" src="assets/core-ui/icons/ic_Danger_24px.svg" alt="Error"
                class="klab-input-text__icon-info" />
            <button *ngIf="showClearIcon" type="button"
                class="klab-input-text__icon-btn klab-input-text__icon-btn--clear" (mousedown)="onIconMouseDown($event)"
                (click)="clearValue($event)">
                <img src="assets/core-ui/icons/ic_Close_24px.svg" alt="Limpiar" class="klab-input-text__icon" />
            </button>
            <button *ngIf="iconRight && !hasError" type="button" class="klab-input-text__icon-btn"
                (mousedown)="onIconMouseDown($event)" (click)="onRightIconClick()">
                <img [src]="iconRightSrc" [alt]="iconRightAlt" class="klab-input-text__icon" />
            </button>
        </div>
    </div>
    <div class="klab-input-text__message" [class.klab-input-text__message--error]="hasError" *ngIf="displayMessage">
        {{ displayMessage }}
    </div>
</div>
